<app-heading
  [title]="'Credentials'"
  [button]="reviewerCredentials && reviewerCredentials.length ? headingButton : null"
  [isbreadcrumb]="from() === 'onboarding' ? false : true"
  [breadcrumbTitleOptions]="breadcrumbTitleOptions"
  [showToggle]="false"
></app-heading>

<div class="flex flex-column">
    <div class="flex flex-column gap-1 text-center h6 mb-3">
      <span>Stand out with verified credentials</span>
    </div>
    <div class="flex flex-column gap-1 text-center mb-3">
      <span>{{ isPWCEnabled ? appName : userFirmName }} is looking for specific credentials. Add any credentials or certifications you have to better position yourself for {{ isPWCEnabled ? 'projects' : 'job offers' }}.</span>
    </div>
    @if (reviewerCredentials && reviewerCredentials.length === 0) {
      @if(!isPWCEnabled){
        <div class="flex flex-column gap-1 h5 text-center mb-3">
          <span>Add My First Credential</span>
        </div>
      }
      <p-button class="text-center mb-3" [styleClass]="headingButton.colorClass"
          (onClick)="addCredentials()"
          [label]="headingButton.label" [rounded]="true" size="large">        
        <span class="{{helperService.getEnvironmentName()}}-icon icon-add-outlined white icon-medium"></span>
      </p-button>
    }
</div>

<div class="flex flex-column container">
  @for(creds of reviewerCredentials; track creds){
  
    <p-accordion [multiple]="true" [activeIndex]="[0]" class="w-full">
      <p-accordionTab>
        <ng-template pTemplate="header">
          <div class="flex align-items-center justify-content-between gap-2 md:gap-4 w-full">
            <div class="flex flex-column line-height-2">
              <span class="md:white-space-nowrap white-space-normal">
                {{ creds.name }}
              </span>
            </div>
            <div class="flex flex-column line-height-2">
              <span class="font-medium white-space-nowrap"> {{'Issue Date' | sentenceCase}} </span>
              <span>
                {{ creds.issuedAt || "-" | date : "MM/dd/yyyy" }}
              </span>
            </div>
            @if(creds.autoRenewal){
              <div class="flex flex-column line-height-2">
                <span class="font-medium white-space-nowrap"> Expiration Date </span>
                @if(creds.expiresAt){
                  <span>
                    {{ creds.expiresAt | date : "MM/dd/yyyy" }}
                  </span>
                } @else {
                  <span>
                    -
                  </span>
                }
              </div>
            } @else {
              <div [hidden]="true" class="flex flex-column line-height-2"></div>
            }
            @if(!creds.isReviewerActivated){
              <p-tag value="Inactive" [rounded]="true" class="pillInactive cursor-pointer"/>
            }
            <div class="mr-4 flex">
              <p-button
                [rounded]="true"
                [text]="true"
                icon="true"
                (onClick)="editMode($event, creds)"
              >
                <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
              </p-button>
              <p-button
                [rounded]="true"
                [text]="true"
                icon="true"
                (onClick)="onDelete($event, creds)"
              >
                <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined"></span>
              </p-button>
            </div>
          </div>
        </ng-template>
        <div class="flex flex-column gap-3">
          <div class="grid">
            @if(creds.secondaryOptionsArray) {
  
            <div class="col-12 flex flex-column gap-1">
              <span class="text-xs text-primary-900 font-medium"
                >{{'Secondary Options' | sentenceCase}}</span
              >
              <div class="flex align-items-center gap-2 flex-wrap">
                @for( option of creds.secondaryOptionsArray; track option) {
                <p-chip label="{{ option }}" [removable]="false" />
  
                }
              </div>
            </div>
            } 
            @if(creds.certificate){
            <div class="col-12 flex flex-column gap-1">
              <span class="text-xs text-primary-900 font-medium">Document</span>
              <div class="flex align-items-center gap-2 flex-wrap">
                <a href="{{ creds.certificate.downloadURL }}" target="_self">
                  <p-chip label="certificate.pdf" [removable]="false" />
                </a>
              </div>
            </div>
            }
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  }
</div>
  
<div class="flex gap-3 mt-3">
  <p-button label="back" rounded="true" outlined="true" size="large"
      styleClass="white-space-nowrap" (onClick)="onBack()"></p-button>
  @if(from() === 'onboarding' && isPWCEnabled){
    <p-button label="next" rounded="true" size="large"
        styleClass="white-space-nowrap" (onClick)="onNext()" styleClass="white-space-nowrap freshgreen-background"></p-button>
  }
</div>